export default __webpack_public_path__ + "static/media/selected.c29d9db6.svg";